// @material-ui/icons
import PhotoLibraryIcon from "@material-ui/icons/PhotoLibrary";
import DashboardIcon from "@material-ui/icons/Dashboard";
import BarChartIcon from "@material-ui/icons/BarChart";
import BookmarkIcon from "@material-ui/icons/Bookmark";
import SupervisedUserCircleIcon from "@material-ui/icons/SupervisedUserCircle";
import MessageIcon from "@mui/icons-material/Message";
import PersonIcon from "@material-ui/icons/Person";
import PostIcon from "@material-ui/icons/PostAdd";
import WorkIcon from "@material-ui/icons/Work";
import PublicIcon from "@material-ui/icons/Public";
import ProductIcon from "@material-ui/icons/LocalOffer";
import CardMembershipIcon from "@mui/icons-material/CardMembership";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

const { email } = JSON.parse(localStorage.getItem("au")) || {};

var dashRoutes = [
	{
		path: "/",
		name: "Dashboard",
		icon: DashboardIcon,
		page: "dashboard",
		roles: ["admin", "editor", "viewer"],
	},
	{
		path: "/products",
		name: "Products",
		icon: ProductIcon,
		page: "products",
		roles: ["admin", "editor", "viewer"],
	},
	{
		path: "/blogs-stories",
		name: "Blogs & Stories",
		icon: PostIcon,
		page: "BlogsAndStories",
		roles: ["admin", "editor", "viewer"],
	},
	{
		path: "/gallery",
		name: "Galleries",
		icon: PhotoLibraryIcon,
		page: "gallery",
		roles: ["admin", "editor", "viewer"],
	},

	{
		path: "/reports",
		name: "Reports",
		icon: BarChartIcon,
		page: "reports",
		roles: ["admin", "editor", "viewer"],
	},
	{
		path: "/metrics",
		name: "Metrics",
		icon: PublicIcon,
		page: "metrics",
		roles: ["admin", "editor", "viewer"],
	},
	{
		path: "/jobs",
		name: "Jobs",
		icon: WorkIcon,
		page: "jobs",
		roles: ["admin", "editor", "viewer"],
	},
	{
		path: "/partners",
		name: "Partners",
		icon: SupervisedUserCircleIcon,
		page: "partners",
		roles: ["admin", "editor", "viewer"],
	},
	{
		path: "/newsletters",
		name: "Newsletters",
		icon: BookmarkIcon,
		page: "newsletters",
		roles: ["admin", "editor", "viewer"],
	},
	{
		path: "/faqs",
		name: "FAQs",
		icon: HelpOutlineIcon,
		page: "faqs",
		roles: ["admin", "editor", "viewer"],
	},
	{
		path: "/messages",
		name: "Messages",
		icon: MessageIcon,
		page: "message",
		roles: ["admin", "editor", "viewer"],
	},
	{
		path: "/subscribers",
		name: "Subscriptions",
		icon: CardMembershipIcon,
		page: "subscribers",
		roles: ["admin", "editor", "viewer"],
	},
	{
		path: "/users",
		name: "Users",
		icon: PersonIcon,
		page: "users",
		roles: ["admin", "editor", "viewer"],
	},
];

export default dashRoutes;
